<script setup lang="ts">
import { articleHeaderVariants } from '~/components/nettbutikk/article/header-variants'

const article = inject(diKeys.article)

const template = computed(() => article?.value.components?.template?.value)

const hasImage = computed(() => !!article?.value.components?.headerImage)

const route = useRoute<'info-page'>()

// FIXME: This shouldn't be hardcoded, but that's the simplest solution for now. This is only used for showing a shape in the header, which should be handled in the CMS if there are more articles with similar needs.
const isCustomerServicePage = computed(() => route.params.slug === 'kundeservice')
</script>

<template>
  <ContentGrid is="header" class="justify-between items-center relative">
    <div :class="articleHeaderVariants.base({ hasImage })">
      <div :class="articleHeaderVariants.title({ hasImage, template, hasShape: isCustomerServicePage })">
        <Shape v-if="isCustomerServicePage" class="absolute hidden lg:block size-40 -left-[--gutter] fill-blurple-200" variant="hexagon" />
        <NettbutikkArticleTitle :text="article?.components.title" />
      </div>

      <div v-if="article?.components?.leadParagraph" :class="articleHeaderVariants.leadParagraph({ hasImage, template, hasShape: isCustomerServicePage })">
        <CrystallizeRichText v-for="(block, i) in article?.components?.leadParagraph" :key="i" :block="block" class="text-2xl font-heading font-semibold" />
      </div>

      <template v-if="template !== 'info-page'">
        <div v-if="article?.components.authorsChoice?.length" class="grid col-span-4 lg:col-span-6 grid-cols-subgrid gap-y-6">
          <NettbutikkArticleAuthor
            v-for="(author, i) in article?.components.authorsChoice"
            :key="i"
            v-slot="{ data }"
            :data="author.value"
            class="col-span-4 md:col-span-2 lg:col-span-3 xl:col-span-2 2xl:col-span-3"
          >
            <p class="font-bold text-base">
              Av
              <NuxtLink v-if="data?.slug" rel="author" class="text-lg" :to="{ name: 'author', params: { slug: data.slug } }">
                {{ data.name }}
              </NuxtLink>
              <span v-else class="text-lg" v-text="data.name" />
            </p>
            <p class="text-xs" v-text="data.title" />
          </NettbutikkArticleAuthor>
        </div>

        <div class="flex col-span-full gap-x-6 gap-y-2 items-center flex-wrap">
          <CrystallizePublished :date="article?.components?.published" icon />
          <ShareLinks icon-size="xs" class="gap-2" link-class="bg-blurple-400 rounded-full text-blurple-200" :title="article?.components.title ?? ''">
            Del:
          </ShareLinks>
        </div>
      </template>
    </div>

    <template v-if="article?.components?.headerImage">
      <CrystallizeClippedImage
        :image="article?.components?.headerImage"
        :path="template === 'info-page' ? 'decagon' : 'octagon-left'"
        class="hidden 2xl:block"
        :class="articleHeaderVariants.imageWrapper({ template })"
        :img-class="articleHeaderVariants.image({ template })"
      />

      <Shape v-if="template === 'info-page'" variant="circle" class="hidden 2xl:block self-stretch ml-12 fill-blurple-200" />
    </template>
  </ContentGrid>
</template>
